import React from 'react'
import styled from 'styled-components'

const Button = ({ text, icon }) => {
    return (
        <Btn>
            <h1>... {text}  <i className={`fab fa-${icon}`}></i></h1>
        </Btn>
    )
}

const Btn = styled.div`
    margin: .1rem 0;
    background: white;
    border: 1px solid lightgray;
    padding: 1rem 2rem;
    color: white;
    background: linear-gradient(to left, #000 50%, #fff 50%) right;
    background-size: 200%;
    transition: .5s ease-out;

    @media (max-width: 768px) {
        font-size: 1rem;
        padding: 0.5rem 1rem;
    }

    & > h1 {
        font-size: 2rem;

        @media (max-width: 768px) {
        font-size: 1rem;
    }
    }

    &:hover {
        background-position: left;
        color: black;
        cursor: pointer;
    }
`;

export default Button
